import types, { IAction } from '../../types/actions';

export interface ILayoutState {
	sidebarShow: boolean;
	sidebarUnfoldable: boolean;
}

export const initialState: ILayoutState = {
	sidebarShow: false,
	sidebarUnfoldable: true,
};

export const layoutReducer = (state: ILayoutState = initialState, action: IAction): ILayoutState => {
	switch (action.type) {
		case types.SET_LAYOUT:
			return { ...state };

		case types.SET_LAYOUT_SIDEBAR:
			return {
				...state,
				sidebarShow: action.payload.sidebarShow,
			};
		case types.SET_LAYOUT_UNFOLDABLE:
			return {
				...state,
				sidebarShow: true,
				sidebarUnfoldable: action.payload.sidebarUnfoldable,
			};
		default:
			return state;
	}
};
